module.exports = __webpack_public_path__ + "static/media/balance buenas noches 2021.eb241d04.png";